import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
	subtitle?: string;
}

const StyledSubtitle = styled.div`
	color: hsl(0, 0%, 0%);
	font-weight: 500;
	font-size: 20px;
	line-height: 24px;
`;

export const Subtitle: FC<Props> = props => {
	const { subtitle = 'Our users have lost over 10 million pounds' } = props;

	return <StyledSubtitle>{subtitle}</StyledSubtitle>;
};
